import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';

/* Imports */
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import * as am5exporting from "@amcharts/amcharts5/plugins/exporting";

import { DatabaseService } from '../../../../core/_services/database.service';
import { LotteryService } from '../../../../core/_services/lottery.service';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { UntypedFormControl } from '@angular/forms';
import { LottteryFrequency } from '../../../../core/_shared/utils/lottery-frequency';
import { WhereFilterOp } from '../../../../core/_services/database-cast/IDatabase';
import { LottolocoTracker } from '../../../../core/_shared/utils/lottolocosTracker';
import { Lottery } from '../../lottoloca-commom/lottery-modex';
import { ControllersService } from '../../../../core/_services/controllers/controllers.service';
import { LotteryDrawn } from '../../../../core/_shared/models/lottery-draw.model';
import { LotteryDrawTask } from '../../../../core/_shared/models/task-queue.model';
import { LotteryTaskStatuses } from '../../../../core/_shared/models/task.model';

@Component({
  selector: 'kt-delay-statistics',
  templateUrl: './delay-statistics.component.html',
  styleUrls: ['./delay-statistics.component.scss']
})
export class DelayStatisticsComponent implements OnInit, OnDestroy {

  subscribleChart: () => void;

  _chartRoot: am5.Root;
  _chart: am5xy.XYChart;
  _description: string;
  _progress: number = 0;
  _showGraph: boolean = true;
  _rangeOptions: { id: number; name: string; }[] = [];
  _groupLens: any[] = [];

  _isControl: boolean = false;
  @Output() public click: EventEmitter<any> = new EventEmitter();
  lastBuildGraph: string;

  _graphHeight: string = "0px";
  _lotteryDrawn: LotteryDrawn;

  _startLotteryDrawControl = new UntypedFormControl();
  _endLotteryDrawControl = new UntypedFormControl();
  _options: string[] = ['One', 'Two', 'Three'];

  _startfilteredOptions: Observable<string[]>;
  _endfilteredOptions: Observable<string[]>;
  _endLotteryDrawLabel: string;
  _startLotteryDrawLabel: string;
  _updateChartLabel: string;
  _groupLen: any = 1;
  _sort: string = "desc";
  _rangeOptionsControl = new UntypedFormControl();

  constructor(
    private _database: DatabaseService,
    private _lotteryService: LotteryService,
    private activateRoute: ActivatedRoute,
    private _controllersService: ControllersService
  ) {
    this._rangeOptionsControl.setValue("1");

    this._startfilteredOptions = this._startLotteryDrawControl.valueChanges
      .pipe(startWith(''), map(value => this._filter(value)));

    this._endfilteredOptions = this._endLotteryDrawControl.valueChanges
      .pipe(startWith(''), map(value => this._filter(value)));

    this._rangeOptionsControl.valueChanges
      .subscribe(() => this.onRefreshClick());

    this._startLotteryDrawLabel = "Concurso inicial";
    this._endLotteryDrawLabel = "Concurso final";
    this._updateChartLabel = "Atualizar Gráfico";
  }

  private _filter(value: string): string[] {
    const filterValue = (value || '').toString().toLowerCase();
    let filtered = this._options.filter(option => option.toLowerCase().includes(filterValue));
    return filtered.length > 100 ? filtered.slice(0, 100) : filtered;
  }

  ngOnInit() {
    LottolocoTracker.saveStatus(this._database, this._lotteryService);
    this.activateRoute.params.subscribe(param => {
      this._groupLen = param.groupLen || 1;
      this._isControl = !param.groupLen;
      this.refreshAll();
    });

    this._lotteryService.getCurrentLotteryMode()
      .then(lottery => {
        lottery.FrequencyStatistics.forEach(groupLen => {
          this._groupLens.push({ id: groupLen, name: LottteryFrequency.getLabelToStatisticsFrequency(groupLen) });
        });
      });
  }

  ngOnDestroy(): void {
    if (this.subscribleChart) this.subscribleChart();
    if (this._chartRoot) this._chartRoot.dispose();
  }

  changeGroupLen(groupLen) {
    if (groupLen != null) {
      this._groupLen = groupLen;
      this.refreshAll();
    }
  }

  refreshAll() {
    this._progress = 0;
    this.clearChart();
    this._description = LottteryFrequency.getLabelToStatisticsFrequency(this._groupLen);
    this._lotteryService.getCurrentLotteryMode().then(lottery => {
      this._database.getLotteryDraws().getLotteryDraw(lottery.id).getData().then(lotteryDrawn => {
        if (lotteryDrawn) {
          this._lotteryDrawn = lotteryDrawn;
          this._options = this._lotteryDrawn.Ids.map(x => parseInt(x.toString()).toString());
          this._startLotteryDrawControl.setValue(parseInt(this._lotteryDrawn.Min));
          this._endLotteryDrawControl.setValue(parseInt(this._lotteryDrawn.Max));
          this.refreshChart();
        }
      });
    });
  }

  refreshChart(): void {
    this._graphHeight = "0px";
    this._progress = 0;
    this.clearChart();

    this._lotteryService.getCurrentLotteryMode().then(lottery => {
      const start = this._lotteryDrawn.Ids.find(x => parseInt(x) == parseInt(this._startLotteryDrawControl.value));
      const end = this._lotteryDrawn.Ids.find(x => parseInt(x) == parseInt(this._endLotteryDrawControl.value));
      this._rangeOptions = lottery.awardParams.map(x => ({ id: x.index, name: x.description }));

      let index = this._rangeOptionsControl.value || "1";
      if (!start || !end || start >= end) return;

      if (this.subscribleChart) this.subscribleChart();

      this.subscribleChart = this._database.getLotteryDraws()
        .getLotteryDraw(lottery.id)
        .getDocument().collection(`statistics/delay/${this._groupLen}`)
        .doc(`${end}-${index}`)
        .onSnapshot(snapshot => {
          let data = snapshot.data();
          if (!data) {
            this.buildGraph(lottery, start, end, index);
          } else if (data.Pages && data.Pages > 0) {
            this._showGraph = true;
            let list = [];
            let operation: WhereFilterOp = data.Pages <= 3 ? ">=" : this._sort == "desc" ? ">=" : "<=";
            let operationValue = data.Pages <= 3 ? 1 : data.Pages - 1;

            this._database.getLotteryDraws()
              .getLotteryDraw(lottery.id)
              .getDocument().collection(`statistics/delay/${this._groupLen}/${end}-${index}/pages`)
              .where("Page", operation, operationValue)
              .get()
              .then(queryResult => {
                queryResult.docs.forEach(doc => list = [...list, ...doc.data().Items]);
                this._graphHeight = `${list.length * 50}px`;
                this.drawChart(list);
              });
          } else {
            this._showGraph = false;
            this._graphHeight = "0px";
            this._progress = data.Progress * 100;
          }
        });
    });
  }

  buildGraph(lottery: Lottery, start: string, end: string, index: any) {
    const currentBuildGraph = `${lottery.id}-${start}-${end}-${index}`;
    if (this.lastBuildGraph === currentBuildGraph) return;

    this._showGraph = false;
    const lotteryDrawTask = new LotteryDrawTask();
    lotteryDrawTask.lotteryId = lottery.id;
    lotteryDrawTask.reportType = "delay";
    lotteryDrawTask.status = LotteryTaskStatuses.Waiting;
    lotteryDrawTask.data = { minId: start, maxId: end, groupLen: this._groupLen, index: index };

    this._controllersService.getTasks().addLotteryDrawnTask(lotteryDrawTask).catch(console.log);
    setTimeout(() => { this.lastBuildGraph = ''; }, 120000);
  }

  public onRefreshClick(): void {
    this.refreshChart();
  }

  clearChart(): void {
    if (this._chartRoot) this._chartRoot.dispose();
    this._chartRoot = am5.Root.new("chartdiv");
    this._chartRoot.setThemes([am5themes_Animated.new(this._chartRoot)]);
    this._chart = this._chartRoot.container.children.push(am5xy.XYChart.new(this._chartRoot, {}));
  }

drawChart(numbers: any[]): void {

    this._chart.xAxes.clear();
  this._chart.yAxes.clear();
  this._chart.series.clear();
  this._showGraph = true;
  if (!this._chartRoot) this.clearChart();

  let data = numbers.map(item => ({
    Key: item.Key,
    Contest: item.Contest,
    Count: parseInt(this._lotteryDrawn.Max) - parseInt(item.Contest)
  }));

  data = this._sort == "asc" ? data.sort((a, b) => a.Count - b.Count) : data.sort((a, b) => b.Count - a.Count);

  const yAxis = this._chart.yAxes.push(am5xy.CategoryAxis.new(this._chartRoot, {
    categoryField: "Key",
    renderer: am5xy.AxisRendererY.new(this._chartRoot, { inversed: true })
  }));

  yAxis.data.setAll(data);  // <---- ESSENCIAL!

  const xAxis = this._chart.xAxes.push(am5xy.ValueAxis.new(this._chartRoot, {
    renderer: am5xy.AxisRendererX.new(this._chartRoot, {})
  }));

  const series = this._chart.series.push(am5xy.ColumnSeries.new(this._chartRoot, {
    name: "Atraso",
    xAxis,
    yAxis,
    valueXField: "Count",
    categoryYField: "Key",
    tooltip: am5.Tooltip.new(this._chartRoot, {
      labelText: this._groupLen.toString() === '1'
        ? "O número {Key} não é sorteado há {Count} concursos\nÚltimo sorteio no concurso: {Contest}"
        : "Os números {Key} não são sorteados juntos há {Count} concursos\nÚltimo sorteio no concurso: {Contest}"
    })
  }));

  series.columns.template.setAll({
    fillOpacity: 1,
    strokeOpacity: 0,
    height: am5.percent(50),
    fill: am5.color(0xf5a9a9)
  });

  series.columns.template.events.on("click", (ev) => {
    const obj = Object.assign({ Key: '' }, ev.target.dataItem.dataContext);
    const numbers = obj.Key.split('-').map(x => parseInt(x));
    this.click.emit(numbers);
  });

  series.data.setAll(data);

  const max = Math.max(...data.map(x => x.Count));
     const min = Math.min(...data.map(x => x.Count));
 
     const medium = (max + min) / 2;
     series.bullets.push((root, series, dataItem) => {
       const value = dataItem.get("valueX");
 
       let color = am5.color("#444444");
       let deslocamento = 5;
       if (value >= medium) {
         deslocamento = -50;
         color = am5.color("#ffffff"); // branco
       }
       return am5.Bullet.new(root, {
         locationX: 1,
         sprite: am5.Label.new(root, {
           text: "{valueX}",
           fill: color,
           centerY: am5.p50,
           centerX: am5.p0,
           dx: deslocamento,
           populateText: true
         })
       });
     });
  const exporting = am5exporting.Exporting.new(this._chartRoot, {
       menu: am5exporting.ExportingMenu.new(this._chartRoot, {}),
       dataSource: {
         data: data.map(d => ({ numero: d.Key, atraso: d.Count })),
         fields: ["numero", "atraso"]  // <-- Obrigatório para CSV aparecer
       },
       filePrefix: "atraso_" + new Date().toISOString().substring(0, 10)
     });
 
}

exportToExcel() {
  const series = this._chart.series.getIndex(0);
  const data = series.dataItems.map(item => {
    const ctx = item.dataContext as any;
    return {
      Número: ctx.Key,
      Atraso: ctx.Count
    };
  });

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = { Sheets: { 'Atraso': worksheet }, SheetNames: ['Atraso'] };
  const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  FileSaver.saveAs(blob, 'Atraso_'+ new Date().toISOString().substring(0, 10)+'.xlsx');
}

  changeSort(event) {
    console.log("Pedir refresh");
    this.refreshChart();
  }
}
